module.exports = __webpack_public_path__ + "static/farsighted-717172953b2daa9c2c88a0b59c9ffe10.jpg";